import React, {useState, useEffect} from "react";
import {useNavigate} from "react-router-dom";
import "../programs/Programs.css";
import "./TherapistsWithRoles.css";
import moment from "moment";
import axios from "axios";

const TherapistsWithRoles = (props) => {
  let navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [contentLoaded, setContentLoaded] = useState(false);
  const [memberData, setMemberData] = useState([]);
  const [isSorted, setSorted] = useState(true);
  const [isOpenRemove, setOpenRemove] = useState(false);
  const [userToRemove, setUserToRemove] = useState(0);
  const [userNameToRemove, setUserNameToRemove] = useState("");

  useEffect(() => {
    setLoading(true);
    axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
    axios
      .post(window.ajaxLink + "cloud_therapist/team-members", {patient_id: props.currentPatient})
      .then((res) => {
        if (res.data.responseData) {
          setLoading(false);
          setMemberData(res.data.responseData);
          setContentLoaded(true);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [props.isTeamOpen, contentLoaded, props.currentPatient]);

  const openCloseDelMember = (event, therapist_data) => {
    event.preventDefault();
    if (therapist_data !== undefined) {
      setUserToRemove(therapist_data.therapist_id);
      setUserNameToRemove(therapist_data.member_name);
    }
    if (isOpenRemove) {
      setUserToRemove(0);
    }
    setOpenRemove(!isOpenRemove);
  };

  const openMemberProfile = (item) => {
    navigate(
      "/patient-details/" +
        item.therapist_id +
        "/" +
        (item.program_id && item.program_id !== undefined ? item.program_id : 0)
    );
    props.setOpenTab("overview");

    if (item.is_therapist === true) {
      localStorage.setItem("isOpenTherapist", true);
    } else {
      localStorage.removeItem("isOpenTherapist");
    }
  };

  const memberDelDismiss = () => {
    setContentLoaded(false);
    if (userToRemove > 0) {
      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios
        .post(window.ajaxLink + "cloud_therapist/remove-team-member", {member_id: userToRemove})
        .then((res) => {
          if (res.data.responseData) {
            setLoading(true);
            setContentLoaded(false);
            setOpenRemove(false);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const handleSorting = (column, array) => {
    if (!isSorted) {
      var sorted = [...array].sort(function (a, b) {
        if (a[column] < b[column]) {
          return -1;
        }
        if (a[column] > b[column]) {
          return 1;
        }
        return 0;
      });
      setSorted(true);
    } else {
      sorted = [...array].sort(function (a, b) {
        if (a[column] > b[column]) {
          return -1;
        }
        if (a[column] < b[column]) {
          return 1;
        }
        return 0;
      });
      setSorted(false);
    }
    setMemberData(sorted);
  };

  return (
    <div className="twroles_dash_top">
      <div style={{maxWidth: 'calc(100vw - 48px)', overflowX: 'auto'}}  className="programs_dash_hold twroles_dash_no_marg">
        {memberData && memberData.length > 0 ? (
          <div  className="programs_table">
            <div className="programs_cols twroles_top_col">
              <div className="programs_col_info">
                <div className="programs_col_name">Virdio Health Team Member</div>
                <div className="programs_col_icon" onClick={() => handleSorting("member_name", memberData)}></div>
              </div>
              <div className="programs_col_info">
                <div className="programs_col_name">Role</div>
                <div className="programs_col_icon" onClick={() => handleSorting("role", memberData)}></div>
              </div>
              <div className="programs_col_info">
                <div className="programs_col_name">Permissions</div>
                {/* <div className="programs_col_icon"></div> */}
              </div>
              <div className="programs_col_info">
                <div className="programs_col_name wrapper_member_date_added">Date Added</div>
                <div className="programs_col_icon" onClick={() => handleSorting("date_added", memberData)}></div>
              </div>
            </div>
          </div>
        ) : !loading ? (
          <div className="programs_table_no_content">
            <div className="no_content_notice_contain">
              {contentLoaded ? (
                <>
                  <div className="programs_no_results_img"></div>
                  <div className="programs_no_res_main">You have no active team members</div>
                  <div className="programs_no_res_elab">You have 0 active team members</div>
                </>
              ) : (
                <div className="p_load"></div>
              )}
            </div>
          </div>
        ) : (
          <div className="loader_full_container">
            <div className="p_load"></div>
          </div>
        )}
        <div className="tbl_content_hold">
          {memberData &&
            memberData.map((item, i) => (
              <div key={i} className="programs_tbl_content current_patient_mark" style={{margin: "24px 0"}}>
                <div className="programs_tbl_row">
                  <div className="programs_tbl_col_contain">
                    <div className="programs_tbl_col">{item.member_name}</div>
                  </div>
                  <div className="programs_tbl_col_contain">
                    <div className="programs_tbl_col patient_team_role">{item.role_name}</div>
                  </div>
                  <div className="programs_tbl_col_contain">
                    <ul className="programs_tbl_col patient_team_perm_ul">
                      {item.therapist_permissions.map((permission) =>
                        permission.value === true ? <li>{permission.key}</li> : ""
                      )}
                    </ul>
                  </div>
                  <div className="programs_tbl_col_contain">
                    <div className="programs_tbl_col patient_team_date_added">{moment(item.date_added).format("L")}</div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
      {isOpenRemove && (
        <div className="dlt_wrapper">
          <div className="dbl_place_on_page">
            <div className="dlt_surround dlt_box">
              <div className="dlt_title">Remove Confirmation</div>
              <div className="dlt_description twroles_pop_text">
                <p>Are you sure you want to remove {userNameToRemove} from your members?</p>
              </div>
              <div className="dlt_exit_btm">
                <div className="dlt_exit_btn dlt_eb_first" onClick={(e) => openCloseDelMember(e)}>
                  Cancel
                </div>
                <div className="dlt_exit_btn dlt_eb_scnd" onClick={() => memberDelDismiss()}>
                  Delete
                </div>
              </div>
            </div>
          </div>
          <div className="approval_close exr_pick_close" onClick={(e) => openCloseDelMember(e)}></div>
        </div>
      )}
    </div>
  );
};

export default TherapistsWithRoles;
